/** Tiny className joiner: `cx(s.a, cond && s.b, className)`. */
export const cx = (...parts: Array<string | number | false | null | undefined>): string =>
    parts.filter((p): p is string => typeof p === 'string' && p.length > 0).join(' ')
